import React from 'react';
import { PapiUser } from '@wix/da-papi-types';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import UserSymbol from '../_partials/UserSymbol';
import { getUserSymbol, getUserTypeId } from '../helpers';
import { useTranslation } from 'react-i18next';
import s from './BasicUserName.scss';

export interface Props {
  user: PapiUser;
  usernameClassName?: string;
  showSymbol?: boolean;
  symbolOpensPopup?: boolean;
  symbolClassName?: string;
  /** Adds owner into the username (I know...) */
  withOwnerText?: boolean;
}

export const BasicUserName: React.FC<React.PropsWithChildren<Props>> =
  React.memo(
    ({
      user,
      showSymbol = true,
      symbolOpensPopup,
      symbolClassName,
      usernameClassName,
      withOwnerText,
    }) => {
      const { t } = useTranslation();

      const username = withOwnerText
        ? `${user.username} ${t('user.identity.owner.concat')}`
        : user.username;

      return (
        <BiLoggerContextProvider
          value={{
            typeid: getUserTypeId(user),
            itemid: user.userId,
          }}
        >
          <span className={usernameClassName ?? s['data-hook-wrapper']}>
            {username}
          </span>
          {showSymbol && (
            <UserSymbol
              userSymbol={getUserSymbol(user)}
              className={symbolClassName}
              openUserSymbolPopup={symbolOpensPopup}
            />
          )}
        </BiLoggerContextProvider>
      );
    }
  );
BasicUserName.displayName = 'BasicUserName';

export default BasicUserName;
